export default "__VITE_ASSET__ZYipTt4F__"